import React from "react";
import router from "./routes/index";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./ThemeContext";
import { SignupJourneyProvider } from "./contexts/SignupJourneyContext";

const App = () => {
  return (
    <ThemeProvider>
      <SignupJourneyProvider>
        <div>
          <RouterProvider router={router} />
        </div>
      </SignupJourneyProvider>
    </ThemeProvider>
  );
};

export default App;
